import React from "react";
import MetaTags from "react-meta-tags";

import Intro from "./Intro";
import Section1 from "./Section1";
import "../SCSS/Styles.css";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import { Helmet } from "react-helmet";
function Csrd() {
  return (
    <>
      <MetaTags>
        <title>CSRD Reporting Tool</title>
        <meta
          name="description"
          content="Promotes greater transparency and accountability in corporate sustainability efforts."
        />
        <meta
          property="og:title"
          content="Promotes greater transparency and accountability in corporate sustainability efforts."
        />
        <meta
          property="og:image"
          content="%PUBLIC_URL%/static/media/banner.jpg"
        />
      </MetaTags>
      <Helmet>
        <link
          rel="alternate"
          hreflang="x-default"
          href="https://www.updapt.com/csrdreportingsoftware"
        />
        <link
          rel="alternate"
          hreflang="en-AE"
          href="https://www.updapt.com/csrdreportingsoftware"
        />
      </Helmet>
      <Intro />
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
    </>
  );
}

export default Csrd;
